///
/// EarthBrowser
///
/// Created by Matt Giger on 10/30/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v57 -> v58: earthbrowser.selectedSatelliteGroupId (one raw CelesTrak
/// group id, or "all") becomes earthbrowser.satelliteSets (multi-select
/// over the curated sets in satelliteSets.ts). "visual" maps to the
/// Brightest set, "all" to every set, any other group to the set that
/// contains it, and anything unknown to the default.
///

import { cDefaultSatelliteSets, cSatelliteSets, setForGroupId } from "@/earthbrowser/dataset-distribution/satellites/satelliteSets"

export function migrateV57toV58(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const earthbrowser = s.earthbrowser as Record<string, unknown> | undefined
	if (!earthbrowser || Array.isArray(earthbrowser.satelliteSets)) return state

	const groupId = earthbrowser.selectedSatelliteGroupId
	let satelliteSets: string[] = [...cDefaultSatelliteSets]
	if (groupId === "all") {
		satelliteSets = cSatelliteSets.map(set => set.id)
	} else if (typeof groupId === "string") {
		const set = setForGroupId(groupId)
		if (set) satelliteSets = [set.id]
	}

	const { selectedSatelliteGroupId: _dropped, ...rest } = earthbrowser
	void _dropped
	return {
		...s,
		earthbrowser: { ...rest, satelliteSets },
	}
}
